import React from "react";

/**
 * DS FilterChip — figma 120:5701 (발주 채널 카운트 칩).
 *
 * pill(radius 999), px-16 py-8, gap 6.
 * label: 16 SemiBold — active 시 Text/Invers, 기본 Text/Tertiary
 * count: 16 Regular Text/Disabled
 * active: bg BG/Black(#0B0D0F) / 기본 bg BG/Paper
 *
 * "전체 142 · 카페24 42 …" 같은 카운트 필터 칩에 사용.
 *
 * @param {object} props
 * @param {React.ReactNode} props.label
 * @param {number} [props.count]
 * @param {boolean} [props.active]
 * @param {() => void} [props.onClick]
 */
const DSFilterChip = ({ label, count, active, onClick, className = "" }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`ds-filter-chip ${active ? "ds-filter-chip--active" : ""} ${className}`}
    >
      <span className="ds-filter-chip__label">{label}</span>
      {count != null && <span className="ds-filter-chip__count">{count}</span>}
    </button>
  );
};

export default React.memo(DSFilterChip);
